export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  chapters: number;
  status: string;
  rating: string;
  tags: string[];
  cover: string;
}

export const comicCategories = ['全部', '热血冒险', '都市恋爱', '悬疑烧脑', '治愈日常'];

export const comics: Comic[] = [
  {
    id: 1,
    title: '星海远征记',
    author: '北辰绘',
    category: '热血冒险',
    chapters: 328,
    status: '连载中',
    rating: '9.6',
    tags: ['太空', '冒险', '少年'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20a%20young%20pilot%20in%20a%20starry%20space%20battleship%20cockpit%2C%20warm%20coral%20and%20deep%20teal%20color%20palette%2C%20dynamic%20composition%2C%20clean%20modern%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-01&orientation=portrait',
  },
  {
    id: 2,
    title: '巷口的柠檬汽水',
    author: '麦芽糖',
    category: '都市恋爱',
    chapters: 156,
    status: '已完结',
    rating: '9.2',
    tags: ['恋爱', '日常', '清新'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20two%20teenagers%20sharing%20a%20lemon%20soda%20at%20a%20cozy%20summer%20street%20cafe%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20light%20romantic%20mood%2C%20clean%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-02&orientation=portrait',
  },
  {
    id: 3,
    title: '七日迷城',
    author: '孤灯夜行',
    category: '悬疑烧脑',
    chapters: 98,
    status: '连载中',
    rating: '9.4',
    tags: ['悬疑', '烧脑', '反转'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20a%20mysterious%20figure%20walking%20through%20a%20foggy%20neon%20city%20alley%20at%20night%2C%20moody%20teal%20and%20dark%20coral%20tone%2C%20suspenseful%20atmosphere%2C%20clean%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-03&orientation=portrait',
  },
  {
    id: 4,
    title: '小森食堂手账',
    author: '一株多肉',
    category: '治愈日常',
    chapters: 204,
    status: '已完结',
    rating: '9.5',
    tags: ['美食', '治愈', '田园'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20a%20small%20countryside%20canteen%20kitchen%20with%20steaming%20food%20and%20a%20smiling%20chef%2C%20warm%20cream%20and%20soft%20green%20tones%2C%20cozy%20healing%20mood%2C%20clean%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-04&orientation=portrait',
  },
  {
    id: 5,
    title: '炎之试炼',
    author: '赤羽匠',
    category: '热血冒险',
    chapters: 412,
    status: '连载中',
    rating: '9.1',
    tags: ['战斗', '少年', '燃'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20a%20warrior%20holding%20a%20flaming%20blade%20against%20a%20fiery%20background%2C%20intense%20coral%20and%20amber%20palette%2C%20epic%20action%20mood%2C%20clean%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-05&orientation=portrait',
  },
  {
    id: 6,
    title: '深夜电台 24:00',
    author: '江上雾',
    category: '悬疑烧脑',
    chapters: 76,
    status: '连载中',
    rating: '9.0',
    tags: ['悬疑', '都市', '声音'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20style%20book%20cover%20illustration%20of%20a%20late%20night%20radio%20studio%20with%20a%20mysterious%20host%20at%20a%20microphone%2C%20dark%20teal%20and%20warm%20lamp%20light%20tones%2C%20eerie%20but%20inviting%20mood%2C%20clean%20manga%20cover%20art%2C%20high%20detail&width=600&height=850&seq=comic-06&orientation=portrait',
  },
];

export interface VolumeChapter {
  id: number;
  title: string;
  pages: number;
  isNew?: boolean;
}

export interface Volume {
  id: number;
  name: string;
  desc: string;
  chapters: VolumeChapter[];
}

export const volumes: Volume[] = [
  {
    id: 1,
    name: '第一卷 · 启程',
    desc: '主角离开小镇，踏上远征序章',
    chapters: [
      { id: 1, title: '第 1 话 风起小镇', pages: 22 },
      { id: 2, title: '第 2 话 陌生的航线', pages: 24 },
      { id: 3, title: '第 3 话 第一颗星', pages: 20, isNew: true },
      { id: 4, title: '第 4 话 约定', pages: 21 },
      { id: 5, title: '第 5 话 启程', pages: 23 },
    ],
  },
  {
    id: 2,
    name: '第二卷 · 深空',
    desc: '穿过小行星带，遭遇第一场危机',
    chapters: [
      { id: 6, title: '第 6 话 星空之外', pages: 25 },
      { id: 7, title: '第 7 话 行星带疾驰', pages: 22 },
      { id: 8, title: '第 8 话 信号', pages: 24 },
      { id: 9, title: '第 9 话 初次交锋', pages: 26 },
      { id: 10, title: '第 10 话 坠落之地', pages: 21 },
    ],
  },
  {
    id: 3,
    name: '第三卷 · 星海',
    desc: '抵达目标星域，结识新的伙伴',
    chapters: [
      { id: 11, title: '第 11 话 陌生大陆', pages: 23 },
      { id: 12, title: '第 12 话 集市偶遇', pages: 20 },
      { id: 13, title: '第 13 话 结盟', pages: 25, isNew: true },
      { id: 14, title: '第 14 话 暗涌', pages: 22 },
      { id: 15, title: '第 15 话 星海之约', pages: 24 },
    ],
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '如何快速跳到想看的章节？',
    a: '在阅读页点击顶部或底部的「目录」按钮，即可打开完整章节列表。列表支持按分卷折叠，点击任意章节即可一键直达，无需从头翻页。',
  },
  {
    q: '什么是分卷阅读？有什么好处？',
    a: '分卷阅读将长篇漫画按故事线拆分为多个卷组，每卷内再分章节。长连载再长也能分卷管理，跨卷跳转、按卷追更都更清晰，阅读进度也不会混乱。',
  },
  {
    q: '我的阅读进度会自动保存吗？',
    a: '会。漫蛙漫画会自动记录你每一卷的最新阅读位置，下次打开可一键续读，进度随心跳跃，换设备登录也能同步。',
  },
  {
    q: '目录跳转会保存卷内位置吗？',
    a: '目录跳转支持两级定位：先选分卷，再点章节。选定章节后，进度会精确停留在你上次阅读的那一页，真正做到章节直达。',
  },
  {
    q: '新章节更新后如何第一时间追到？',
    a: '收藏你追更的作品后，新章更新会在「我的追更」中置顶提醒，并标注「最新」标签，点击即可直达新章节，追更效率翻倍。',
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: '星野酱',
    role: '追更 300+ 话的长篇用户',
    text: '以前每部长篇都要从头翻，现在直接目录跳章，收藏的连载更新了马上能跳到最新话，省了太多时间。',
  },
  {
    name: '老漫迷阿凯',
    role: '分卷收藏爱好者',
    text: '分卷阅读太适合那种几百话的大长篇了，按卷管理进度，跨卷跳转清清楚楚，追更效率真的翻倍。',
  },
  {
    name: '柠檬气泡',
    role: '通勤路上的读者',
    text: '在地铁上就靠章节直达续读，进度随心跳跃，再也不用记自己看到哪了，体验非常顺滑。',
  },
];

export const guideSteps = [
  {
    title: '打开目录',
    desc: '进入任意漫画详情页，点击「目录」即可展开全部分卷与章节列表。',
    icon: 'ri-file-list-3-line',
  },
  {
    title: '选择分卷',
    desc: '长篇漫画按卷折叠，先定位到目标分卷，快速缩小查找范围。',
    icon: 'ri-stack-line',
  },
  {
    title: '章节直达',
    desc: '点击目标章节一键直达，无需翻页，进度自动记录并保存。',
    icon: 'ri-corner-up-right-line',
  },
  {
    title: '同步追更',
    desc: '收藏作品后，新章更新置顶提醒，一键续读，追更效率翻倍。',
    icon: 'ri-refresh-line',
  },
];